<template>
    <div ref="footer" class="footer" :class="{fixed: fixed}">
        <p class="footer--location">12 rue mansart 75009 Paris</p>
        <a class="footer--contact" href="mailto:contact@jiaszeto.com">contact@jiaszeto.com</a>
    </div>
</template>

<script>
import { TimelineMax, Expo } from 'gsap';

export default {
    props: {
        fixed: Boolean
    },
    methods: {
        animateUnmount() {
            const {footer} = this.$refs;

            let tl = new TimelineMax();
            tl
            .to(footer, 2, {bottom: '-5rem', opacity: 0, ease: Expo.easeOut});
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Footer.vue